export const ENDPOINT_FILE_UPLOAD = '/api/files/upload';
